<script lang="ts">
    import { onMount, getContext } from "svelte";
    import { Link, useNavigate } from "svelte-navigator";
    import { loader, api, swClient, toast, user } from "../stores";
    import ConfirmPopup from "../modals/ConfirmPopup.svelte";
    import type { CreatePageIn, Document, Product } from "./../model";
    import { Types } from "../model";
    import ProductPrice from "../product/ProductPrice.svelte";
    import type { Category } from "../solidwind";
    import { MatrixChecker } from "./MatrixChecker";

    export type Parameter = "edit" | "delete" | "transfert";

    export let params: Parameter[] = ["edit", "delete"];
    export let document_uid;
    const { open } = getContext("simple-modal");
    const navigate = useNavigate();

    let document: Document = null;
    let categories: Category[] = null;

    let showedItems = 15;
    let last_scroll;
    let productsDiv;

    let search_text = "";
    let last_search_text = "";

    let all_products: Product[] = null;
    let products = null;
    let campaign = null;
    let codeOpe: string = null;
    let isInit = false;

    let userType = null;

    let campaignType = "";

    let sortSelected: "alpha" | "priceUp" | "priceDown" = "alpha";
    let listMode: "document" | "campaign" = "document";

    let centraleFilterValue: string = "all";
    const centralesValues: string[] = [];

    const handleImgError = (ev) => (ev.target.src = "/no_visual.jpg");

    onMount(async () => {
        categories = await $swClient.getCategories();
        await getProductsByDocument();
    });

    async function getProductsByDocument() {
        const processId = $loader.show("Chargement des produits");

        $api.getProductByDocument(document_uid)
            .then(
                async (result) => {
                    document = await $swClient.getDocument(document_uid);
                    campaign = await $swClient.getCampaign(
                        document.campaign_uid
                    );
                    campaignType = campaign.type.name;
                    for (let i = 0; i < campaign.attrs.length; i++) {
                        const attr = campaign.attrs[i];
                        if (attr.key === "code") {
                            codeOpe = attr.value;
                            break;
                        }
                    }
                    result = result.sort((a, b) => {
                        return a.name
                            .replace(/["']/g, "")
                            .trim()
                            .localeCompare(b.name.replace(/["']/g, "").trim());
                    });

                    all_products = result;
                    products = result;
                    isInit = true;
                },
                (err) => {
                    console.error(err);
                }
            )
            .finally(() => {
                $loader.hide(processId);
            });
    }

    async function getProductsByCampaign() {
        const processId = $loader.show("Chargement des produits disponibles");

        $api.getProductByCampaign(document.campaign_uid)
            .then(
                async (result) => {
                    result = result
                        .sort((a, b) => {
                            return a.name
                                .replace(/["']/g, "")
                                .trim()
                                .localeCompare(
                                    b.name.replace(/["']/g, "").trim()
                                );
                        })
                        .filter(
                            (e) =>
                                !products.find((el) => {
                                    return el.uid === e.uid;
                                })
                        )
                        .filter((e) => {
                            if (document.categories.length !== 0) {
                                let catUids: string[] = [];
                                if (e.france1) {
                                    catUids.push(
                                        categories.find(
                                            (category) => category.name === "A"
                                        ).uid
                                    );
                                }
                                if (e.france2) {
                                    catUids.push(
                                        categories.find(
                                            (category) => category.name === "B"
                                        ).uid
                                    );
                                }
                                if (e.france3) {
                                    catUids.push(
                                        categories.find(
                                            (category) => category.name === "C"
                                        ).uid
                                    );
                                }
                                return catUids.some((catUid) =>
                                    document.categories.includes(catUid)
                                );
                            } else {
                                return true;
                            }
                        })
                        .filter((e) => {
                            if (document.geo_area) {
                                return (
                                    document.geo_area.name === e.geoArea ||
                                    e.geoArea == ""
                                );
                            } else {
                                return true;
                            }
                        });
                    products = result;
                    all_products = result;
                    isInit = true;
                },
                (err) => {
                    console.error(err);
                }
            )
            .finally(() => {
                $loader.hide(processId);
            });
    }

    async function wheelEvent(event) {
        if (event.deltaY > 0) {
            showedItems++;
        }
    }

    async function handle_scroll() {
        if (productsDiv.scrollTop > last_scroll) {
            showedItems++;
        }
        last_scroll = productsDiv.scrollTop;
    }

    function filterProducts() {
        let searchValueNorm;

        if (search_text) {
            searchValueNorm = search_text
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        }

        if (last_search_text.length > search_text.length) {
            showedItems = 15;
            productsDiv.scrollTop = 0;
        }

        products = all_products
            .sort((a, b) => {
                if (sortSelected === "alpha") {
                    return a.name
                        .replace(/["']/g, "")
                        .trim()
                        .localeCompare(b.name.replace(/["']/g, "").trim());
                } else if (sortSelected === "priceUp") {
                    return (Number(a.price) || 0) - (Number(b.price) || 0);
                } else if (sortSelected === "priceDown") {
                    return (Number(b.price) || 0) - (Number(a.price) || 0);
                }
                return 0;
            })
            .filter((product) => {
                let itemNameNorm;
                let itemBrandNorm;
                itemNameNorm = product.name
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");
                itemBrandNorm = product.brand
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");
                return (
                    (search_text === "" ||
                        itemNameNorm
                            .toLowerCase()
                            .indexOf(searchValueNorm.toLowerCase()) !== -1 ||
                        itemBrandNorm
                            ?.toLowerCase()
                            .indexOf(searchValueNorm.toLowerCase()) !== -1 ||
                        product.ean == searchValueNorm) &&
                    (centraleFilterValue == "all" ||
                        (centraleFilterValue == "natio" &&
                            product.geoArea == "") ||
                        (centraleFilterValue == "regio" &&
                            product.geoArea != ""))
                );
            });

        last_search_text = search_text;
    }

    /**
     * Delete the selected product on the current document
     * if the product comes from the national document, it is only removed from the current page
     * if not, it is completely removed from the campaign
     * @param product product to delete
     * @param index index of the product in the displayed list
     */
    function onDeleteProduct(product: Product, index: number) {
        if (checkParams("delete")) {
            open(
                ConfirmPopup,
                {
                    onOkay: () => deleteProductAsync(product, index),
                    title: `Supprimer le produit ${product.name} du document ?`,
                    content: "",
                },
                {
                    closeOnOuterClick: false,
                    closeOnEsc: false,
                    closeButton: false,
                }
            );
        }
    }

    const deleteProductAsync = async (product: Product, index: number) => {
        const processId = $loader.show("Suppression du produit...");
        const pro = await $swClient.get(`/v2/products/${product.uid}`);
        const doc = await $swClient.get(`/v2/documents/${document_uid}`);
        try {
            //removeProductByPage
            await $swClient.delete(
                `/v2/document-pages/${doc.pages[0]}/versions/last/products/${product.uid}`,
                null,
                null
            );
            // if regional product
            if (
                pro.geo_area.name != "" &&
                pro.geo_area.name == doc.geo_area.name
            ) {
                //remove product asset
                for (let i = 0; i < pro.assets.length; i++) {
                    const asset = pro.assets[i];
                    console.log(asset);
                    await $swClient.delete(
                        `/v2/products/${product.uid}/assets/${asset}`,
                        null,
                        null
                    );
                }
                //remove product
                await $swClient.delete(
                    `/v2/products/${product.uid}`,
                    { deep: true },
                    null
                );
            } else {
                // add to campaign cache
                if (
                    $api.all_products[doc.campaign_uid] &&
                    !$api.all_products[doc.campaign_uid].find(
                        (e) => e.uid === product.uid
                    )
                ) {
                    $api.all_products[doc.campaign_uid].push(product);
                    $api.all_products[doc.campaign_uid] =
                        $api.all_products[doc.campaign_uid];
                }
            }
            // remove from displayed list
            products.splice(index, 1);
            products = products;
            $toast.success(`Le produit a été supprimé avec succès`);
        } catch (err) {
            console.error(err);
            $toast.error(
                `Erreur lors de la suppression du produit : ${err.body.msg}`,
                10000
            );
        } finally {
            $loader.hide(processId);
        }
    };

    function toCampaignMode() {
        listMode = "campaign";
        params = ["transfert"];
        getProductsByCampaign();
    }

    function toDocumentMode() {
        listMode = "document";
        params = ["edit", "delete"];
        getProductsByDocument();
    }

    function checkParams(param: Parameter): boolean {
        return params.includes(param);
    }

    async function onTransfertProduct(product: Product, index: number) {
        const processId = $loader.show("Transfert du produit...");
        transfertProduct(product, index)
            .then(() => {
                $toast.success(`Le produit a été transferé avec succès`);
            })
            .catch((err) => {
                console.error(err);
                $toast.error(
                    `Erreur lors du transfert du produit : ${err.body.msg}`,
                    10000
                );
            })
            .finally(() => {
                $loader.hide(processId);
            });
    }

    async function onTransfertAllProducts() {
        const processId = $loader.show("Transfert de tous les produits...");
        for await (const [i, product] of products.entries()) {
            await transfertProduct(
                product,
                products.indexOf((e) => e.uid === product.uid)
            );
        }
        $loader.hide(processId);
    }

    async function transfertProduct(
        product: Product,
        index: number
    ): Promise<any> {
        if (checkParams("transfert")) {
            // if document aren't page
            if (document.pages.length === 0) {
                const processIdPage = $loader.show(
                    "Aucune page trouvée, création d'une page..."
                );
                try {
                    // create page
                    let page = await $swClient.createPage(
                        document.campaign_uid
                    );
                    // create version page with datafile uid of emtpy page (same uid between prod and staging)
                    await $swClient.createPageVersion(page.uid);
                    // add page to document
                    await $swClient.addPageToDocument(document.uid, page.uid);
                    // add page in document variable
                    document.pages = [...document.pages, page.uid];
                    // add sectors to page
                    let sectors = await $swClient.getSectors();
                    for await (const sector of sectors) {
                        await $swClient.addSectorToPage(page.uid, sector.uid);
                    }
                } catch (err) {
                    console.error(err);
                    console.log(err.body);
                    $toast.error(`Erreur lors de la création de page`, 10000);
                    return;
                } finally {
                    $loader.hide(processIdPage);
                }
            }
            // add product to first page of document
            $swClient
                .putProductToPage(product.uid, document.pages[0])
                .then((res) => {
                    products.splice(index, 1);
                    products = products;
                    $api.all_products[document.campaign_uid].splice(
                        (e) => e.indexOf((el) => el.uid === e.uid),
                        1
                    );
                    $api.all_products[document.campaign_uid] =
                        $api.all_products[document.campaign_uid];
                    if (
                        $api.all_products[document.uid] &&
                        !$api.all_products[document.uid].find(
                            (e) => e.uid === product.uid
                        )
                    ) {
                        $api.all_products[document.uid] = [
                            ...$api.all_products[document.uid],
                            product,
                        ];
                    }
                })
                .catch((err) => {
                    console.error(err);
                    $toast.error(
                        `Erreur lors du transfert du produit : ${err.body.msg}`,
                        10000
                    );
                })
                .finally(() => {
                    return;
                });
        } else {
            console.error("product list must be on 'transfert' mode");
            return;
        }
    }

    async function importMatrice(e, selectedDocument) {
        const document_name = selectedDocument.name.split("_")[0];
        const document_uid = selectedDocument.uid;
        const file = e.target.files[0];
        const fileName: string = file.name.split(".")[0];
        const sectors = await $swClient.getSectors();
        const mc = new MatrixChecker(file);

        const foundErrors = await mc.readExceldocumentAsync(sectors);
        if (foundErrors.length > 0) {
            open(
                ConfirmPopup,
                {
                    title: "Nous avons détecté une (des) anomalie(s)",
                    content: `${foundErrors.join("<hr>")}`,
                    showConfirm: false,
                    cancelText: "Fermer",
                },
                { closeOnOuterClick: false }
            );
        } else {
            const onImport = async () => {
                const loaderId = $loader.show(
                    "Votre matrice est en cours d'import, merci de patienter quelques instants ..."
                );
                $api.postExcelImport(document_uid, file, $swClient.token)
                    .then(async (res) => {
                        $loader.hide(loaderId);
                        // suggest seeing the report
                        if (res) {
                            const onOkay = async () => {
                                res.blob().then((b) => {
                                    let a = document.createElement("a");
                                    a.href = URL.createObjectURL(b);
                                    a.setAttribute(
                                        "download",
                                        "log_import_matrice_" + document_name
                                    );
                                    a.click();
                                });
                            };
                            // update products list
                            await getProductsByDocument();

                            // // open the modal
                            // open(
                            //     ConfirmPopup,
                            //     {
                            //         onOkay,
                            //         title:
                            //             "L'import " +
                            //             document_name +
                            //             " est terminé",
                            //         content:
                            //             "Souhaitez-vous avoir le rapport d'exécution ?",
                            //     },
                            //     {
                            //         closeOnOuterClick: false,
                            //         closeOnEsc: false,
                            //         closeButton: false,
                            //     }
                            // );
                        }
                    })
                    .catch((e) => {
                        $loader.hide(loaderId);
                        $toast.error(
                            "Une erreur s'est produite, l'import ne s'est pas exécuté correctement.",
                            10000
                        );
                        console.error(e);
                    });
            };
            const onOkay = async () => {
                await onImport();
            };

            // verify if file name include document name
            // if (!fileName.includes(document_name)) {
            //     // open the modal
            //     open(
            //         ConfirmPopup,
            //         {
            //             onOkay,
            //             title: "Nous avons détecté une anomalie",
            //             content:
            //                 "Le nom du fichier (" +
            //                 file.name +
            //                 ") que vous souhaitez importer ne contient pas le nom du document (" +
            //                 document_name +
            //                 ")." +
            //                 " Êtes-vous certain de vouloir importer ce fichier sur " +
            //                 document_name +
            //                 " ?",
            //         },
            //         {
            //             closeOnOuterClick: false,
            //             closeOnEsc: false,
            //             closeButton: false,
            //         }
            //     );
            // } else {
            onImport();
            // }
        }
    }
</script>

<div class="sticky-menu">
    {#if isInit}
        <div id="header">
            <div class="header-left">
                <div class="return mt-1 pl-2">
                    <button class="button is-light">
                        <span class="desktop" on:click={() => navigate(-1)}>
                            <i class="fas fa-chevron-left" /> Retour
                        </span>
                    </button>
                </div>
                <div class="campaign-title">
                    {campaign.name} - {codeOpe}
                </div>
            </div>
            <div class="header-right">
                <label class="button btn-elpev btn-file">
                    <input
                        type="file"
                        accept=".xlsx"
                        on:change={(e) => {
                            importMatrice(e, document);
                        }}
                    />
                    Importer les produits
                </label>
                {#if listMode === "document"}
                    <Link to="/admin/products/{document_uid}/new">
                        <button class="button btn-elpev mx-1">
                            <span>Créer un produit</span>
                        </button>
                    </Link>
                {/if}
                {#if listMode === "campaign"}
                    <button
                        class="button btn-elpev mx-1"
                        on:click={onTransfertAllProducts}
                        disabled={products.length === 0}
                    >
                        <span
                            >Ajouter tous les produits ({products.length})</span
                        >
                    </button>
                    <button
                        class="button cancel mx-1"
                        on:click={toDocumentMode}
                    >
                        <span>Revenir</span>
                    </button>
                {/if}
                {#if listMode === "document"}
                    <button
                        class="button btn-elpev mx-1"
                        on:click={toCampaignMode}
                    >
                        <span>Ajouter des produits existants</span>
                    </button>
                {/if}
            </div>
        </div>
    {/if}

    {#if products !== null}
        <div class="columns mb-0">
            <div class="column">
                <div id="search" class="p-l-2 p-r-2 p-b-2">
                    <div class="field">
                        <p class="control has-icons-left">
                            <input
                                class="input"
                                type="text"
                                placeholder="Rechercher un produit par libellé, marque ou ean"
                                bind:value={search_text}
                                on:keyup={() => {
                                    filterProducts();
                                }}
                            />
                            <span class="icon is-small is-left">
                                <i class="fas fa-search" />
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="column is-narrow">
                <div class="buttons has-addons">
                    <button
                        on:click={() => {
                            sortSelected = "alpha";
                            filterProducts();
                        }}
                        class="button {sortSelected === 'alpha'
                            ? 'is-dark is-selected'
                            : ''}"
                        >Alphabétique
                    </button>
                    <button
                        on:click={() => {
                            sortSelected = "priceUp";
                            filterProducts();
                        }}
                        class="button {sortSelected === 'priceUp'
                            ? 'is-dark is-selected'
                            : ''}"
                        >Prix croissant
                    </button>
                    <button
                        on:click={() => {
                            sortSelected = "priceDown";
                            filterProducts();
                        }}
                        class="button {sortSelected === 'priceDown'
                            ? 'is-dark is-selected'
                            : ''}"
                        >Prix décroissant
                    </button>
                </div>
            </div>
        </div>
    {/if}
</div>


<div class="product-line columns header">
    <div class="product-case column is-one-fifth product-img">Aperçu</div>
    <div class="product-case column is-one-fifth">Titre</div>
    <div class="product-case column is-one-fifth product-price">Prix</div>
    <div class="product-case column is-one-fifth">Actions</div>
    <div class="product-case column is-one-fifth">Publier</div>
</div>
{#if products !== null}
    <div
        id="productList"
        bind:this={productsDiv}
        on:wheel={wheelEvent}
        on:scroll={handle_scroll}
    >
        {#each products as product, i}
            {#if i < showedItems}
                <div class="product-line columns">
                    <div class="product-case column is-one-fifth product-img">
                        <img
                            on:error={handleImgError}
                            src="{product.images[0]}?g=80x80"
                            alt=""
                        />
                    </div>
                    <div class="product-case is-one-fifth column">
                        {product.name}
                        {product.brand}
                    </div>
                    <div class="product-case column is-one-fifth product-price">
                        <ProductPrice {product} />
                    </div>
                    <div class="product-case column is-one-fifth">
                        {#if checkParams("edit")}
                            <Link
                                to="/admin/product/{document_uid}/{product.uid}"
                            >
                                <button class="button edit">
                                    <i class="fas fa-pen" />
                                </button>
                            </Link>
                        {/if}
                        {#if checkParams("delete")}
                            <button
                                class="button is-danger"
                                on:click={() => onDeleteProduct(product, i)}
                            >
                                <i class="fas fa-trash-alt" />
                            </button>
                        {/if}
                        {#if checkParams("transfert")}
                            <button
                                class="button is-warning"
                                on:click={() => onTransfertProduct(product, i)}
                            >
                                <i class="fas fa-arrow-up" />
                            </button>
                        {/if}
                    </div>
                    <div class="product-case column is-one-fifth">
                        {#if product.fb_link}
                            <img
                                on:click={() => {
                                    window.open(product.fb_link, "_blank");
                                }}
                                style="cursor: pointer;"
                                width="45"
                                height="45"
                                src="/img/fb_icon.png"
                                alt=""
                            />
                        {/if}
                    </div>
                </div>
            {/if}
        {/each}
    </div>
{/if}

<style lang="scss">
    @import "../styles/variables.scss";

    .cancel {
        background-color : $red;
        color: white;
        border-radius: 12px;
    }
    .campaign-title {
        color: black;
        font-weight: 900 !important;
        font-family: "Gilmer Bold" !important;
        font-size: 1.5rem;
    }
    .sticky-menu {
        float: left;
        width: 100%;
        height: 115px;

        #header {
            width: 100%;
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;

        }
    }

    .header {
        background-color: $beige;
        border-radius: 12px;
        width: 100%;
        text-align: left;
        .product-case {
            color: black;
            font-weight: 900 !important;
            font-family: "Gilmer Bold" !important;
        }
        margin: unset;
        margin-bottom: 1rem;
    }

    .button.edit {
        background-color: $dark-black;
        color: white;
        border-radius: 10px;
    }

    .button.is-danger {
        border-radius: 10px;
    }

    .is-light {
        background-color: $light-white;
        color: black;
        border: 1px solid black;
    }

    .header-left {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        margin-right: auto;
        align-items: center;
    }
    .header-right {
        display: flex;
        margin-left: auto;
        flex-direction: row;
        gap: 5px;
        align-items: center;
    }
    #productList {
        height: 100%;
        width: 100%;
        display: flex;
        gap: 1rem;
        flex-direction: column;
        overflow-x:  auto;
        max-height: calc(100% - 178px);

        .product-line.columns {
            margin: unset;
        }
    }

    #search {
        width: 100%;
        float: left;
        height: 60px;
    }

    .product-line {
        width: 100%;

        border-radius: 12px;
        &:not(.header) {
            border: 1px solid $grey-light;
            height: 95px;
        }

        &.bg-beige {
            background-color: $beige;
        }

        .product-case {
            &.product-img {
                text-align: center;

                img {
                    max-height: 80px;
                }
            }

            &.product-price {
                text-align: start;

                span {
                    color: $dark-blue;
                    font-size: 1.5em;
                }
            }

            &.product-pastille {
                transform: scale(0.75) !important;
            }
        }

        .column {
            // padding: 0.25em !important;
        }
    }

    .return {
        height: 40px;
        float: left;
        span {
            color: $dark-black;
            font-weight: bold;
            font-size: 1.2em;
            cursor: pointer;
        }
    }

    .btn-file {
        input[type="file"] {
            display: none;
        }
    }
</style>
